import { render, staticRenderFns } from "./serverDetailPerformance.vue?vue&type=template&id=4bba1718&"
import script from "./serverDetailPerformance.vue?vue&type=script&lang=js&"
export * from "./serverDetailPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports